// assets/header-dropdown.js (VERSIÓN CONSERVADORA)
(function(){
  'use strict';
  const DROPLINKS_MAP = {
    'compra leads': [
      { text: 'Beneficios En Vida | WhatsApp', href: '/collections/whatsapp' },
      { text: 'Beneficios En Vida | Facebook Form', href: '/collections/facebook-form' }
    ],
    'soporte': [
      { text: 'Contáctanos', href: '/pages/contact' },
      { text: 'Reemplazo de Leads', href: '/pages/reemplazo-de-leads' },
            { text: 'FAQ', href: '/pages/faq' }

    ]
  };

  const MIN_DESKTOP = 1024;
  const HIDE_DELAY_MS = 260;
  const norm = s => (s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();

  function createChevron(){
    const b = document.createElement('button');
    b.type='button'; b.className='hd-chevron';
    b.setAttribute('aria-haspopup','true'); b.setAttribute('aria-expanded','false');
    b.style.border='0'; b.style.background='transparent'; b.style.cursor='pointer';
    b.style.marginLeft='6px'; b.style.padding='4px';
    b.innerHTML = `<svg width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    return b;
  }

  function createDropdown(id, items){
    let dd = document.getElementById(id);
    if(!dd){
      dd = document.createElement('div');
      dd.id = id; dd.className = 'dropdown-small hd-injected';
      dd.setAttribute('role','menu'); dd.setAttribute('aria-hidden','true');
      Object.assign(dd.style, {
        position:'absolute', background:'#fff', borderRadius:'10px', padding:'8px 0',
        boxShadow:'0 16px 40px rgba(11,34,58,0.12)', border:'1px solid rgba(11,34,58,0.06)',
        zIndex:20000, opacity:0, transform:'translateY(-6px)', pointerEvents:'none', transition:'opacity .14s ease, transform .14s ease', display:'none'
      });
      document.body.appendChild(dd);
    }
    dd.innerHTML = `<ul style="list-style:none;margin:0;padding:0;">${items.map(i=>`<li style="padding:10px 18px;"><a href="${i.href}" style="display:block;color:var(--color-foreground,#0b223a);text-decoration:none;font-weight:600;">${i.text}</a></li>`).join('')}</ul>`;
    return dd;
  }

  function positionDropdown(dd, anchor){
    if(!dd || !anchor) return;
    const r = anchor.getBoundingClientRect();
    dd.style.left='0px'; dd.style.top='0px'; dd.style.display='block';
    const w = dd.offsetWidth || 260, h = dd.offsetHeight || 140;
    let left = r.left + r.width/2 - w/2 + window.scrollX;
    left = Math.max(8 + window.scrollX, Math.min(left, window.innerWidth - w - 8 + window.scrollX));
    let top = r.bottom + 10 + window.scrollY;
    if (window.innerHeight - r.bottom < h + 20) top = r.top - h - 10 + window.scrollY;
    dd.style.left = left + 'px'; dd.style.top = top + 'px';
  }

  function openDropdown(dd, anchor, chevron, anchorLink){
    if(!dd) return;
    positionDropdown(dd, anchor);
    dd.style.display='block';
    requestAnimationFrame(()=> {
      dd.style.opacity='1'; dd.style.transform='translateY(0)'; dd.style.pointerEvents='auto';
      dd.setAttribute('aria-hidden','false');
      if(chevron) chevron.setAttribute('aria-expanded','true');
      if(anchorLink) anchorLink.setAttribute('aria-expanded','true');
    });
  }

  function closeDropdown(dd, chevron, anchorLink){
    if(!dd) return;
    dd.style.opacity='0'; dd.style.transform='translateY(-6px)';
    dd.style.pointerEvents='none'; dd.setAttribute('aria-hidden','true');
    if(chevron) chevron.setAttribute('aria-expanded','false');
    if(anchorLink) anchorLink.setAttribute('aria-expanded','false');
    setTimeout(()=> dd.style.display='none', 150);
  }

  function attachToExact(header, label){
    const normalized = norm(label);
    // buscar SOLO en .menu-list__link (desktop nav)
    const links = Array.from(header.querySelectorAll('.menu-list__link'));
    const match = links.find(a => norm(a.textContent||'') === normalized);
    if(!match){
      console.warn('[hd] no encontre link exacto para', label);
      return false;
    }
    if(match.dataset.hdBound === '1') return true;

    const chevron = createChevron();
    // insertar el chevron al final del link sin romper estructura
    match.appendChild(chevron);

    const ddId = `dropdown-${normalized.replace(/\s+/g,'-')}`;
    const dd = createDropdown(ddId, DROPLINKS_MAP[normalized]);

    // hover-delay
    let t=null;
    const scheduleHide = () => { clearTimeout(t); t = setTimeout(()=> closeDropdown(dd, chevron, match), HIDE_DELAY_MS); };
    const cancelHide = () => { clearTimeout(t); t = null; };

    match.addEventListener('mouseenter', ()=> { cancelHide(); openDropdown(dd, match, chevron, match); });
    match.addEventListener('mouseleave', scheduleHide);

    dd.addEventListener('mouseenter', cancelHide);
    dd.addEventListener('mouseleave', scheduleHide);

    chevron.addEventListener('click', (e)=> {
      e.preventDefault(); e.stopPropagation();
      const open = dd.getAttribute('aria-hidden') === 'false';
      if(open) closeDropdown(dd, chevron, match); else openDropdown(dd, match, chevron, match);
    });

    match.dataset.hdBound = '1';
    chevron.dataset.hdBound = '1';
    return true;
  }

  function init(){
    if(window.innerWidth < MIN_DESKTOP) return;
    const header = document.querySelector('header');
    if(!header) return;
    // attach only to the two exact labels we want, if found
    attachToExact(header, 'Compra Leads');
    attachToExact(header, 'Soporte');
  }

  // start with retries + observer
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  let tries = 0;
  const iv = setInterval(()=>{ init(); tries++; if(tries>40) clearInterval(iv); }, 300);
  const root = document.querySelector('header')||document.body;
  new MutationObserver(init).observe(root, { childList:true, subtree:true });

})();
